import * as actions from './actions';

const initialState = {
  // Separate store for settings metadata
  settingsMetaData: {
    data: null,
    businessContextId: null,
    isLoading: false,
    error: null
  },
  // Separate store for supported event types
  supportedEventTypes: {
    data: null,
    businessContextId: null,
    options: null,
    productIntegrationOptions: null,
    allEventTypeCategoryOptions: null,
    allEventOptions: null,
    internalSurveyResponseOptions: null,
    externalSurveyResponseOptions: null,
    productCategories: null,
    productNames: null,
    isLoading: false,
    error: null
  }
};

export default function copyTemplateModalReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GETTING_COPY_MODAL_CONTEXT_DATA:
      return {
        ...state,
        error: null,
        settingsMetaData: {
          ...state.settingsMetaData,
          isLoading: true,
          error: null
        },
        supportedEventTypes: {
          ...state.supportedEventTypes,
          isLoading: true,
          error: null
        }
      };

    case actions.GETTING_COPY_MODAL_CONTEXT_DATA_SUCCEEDED:
      const { settingsMetaData, supportedEventTypes, businessContextId } = action.payload;
      return {
        ...state,
        settingsMetaData: {
          data: settingsMetaData,
          businessContextId: businessContextId,
          isLoading: false,
          error: null
        },
        supportedEventTypes: {
          data: supportedEventTypes?.data || null,
          businessContextId: businessContextId,
          options: supportedEventTypes?.options || null,
          productIntegrationOptions: supportedEventTypes?.productIntegrationOptions || null,
          allEventTypeCategoryOptions: supportedEventTypes?.allEventTypeCategoryOptions || null,
          allEventOptions: supportedEventTypes?.allEventOptions || null,
          internalSurveyResponseOptions: supportedEventTypes?.internalSurveyResponseOptions || null,
          externalSurveyResponseOptions: supportedEventTypes?.externalSurveyResponseOptions || null,
          productCategories: supportedEventTypes?.productCategories || null,
          productNames: supportedEventTypes?.productNames || null,
          isLoading: false,
          error: null
        }
      };

    case actions.GETTING_COPY_MODAL_CONTEXT_DATA_FAILED:
      return {
        ...state,
        settingsMetaData: {
          ...state.settingsMetaData,
          isLoading: false,
          error: action.payload
        },
        supportedEventTypes: {
          ...state.supportedEventTypes,
          isLoading: false,
          error: action.payload
        }
      };

    case actions.GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES:
      return {
        ...state,
        supportedEventTypes: {
          ...state.supportedEventTypes,
          isLoading: true,
          error: null
        }
      };

    case actions.GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_SUCCEEDED:
      const supportedEventTypesData = action.payload;
      return {
        ...state,
        supportedEventTypes: {
          ...state.supportedEventTypes,
          data: supportedEventTypesData?.data || null,
          options: supportedEventTypesData?.options || null,
          productIntegrationOptions: supportedEventTypesData?.productIntegrationOptions || null,
          allEventTypeCategoryOptions: supportedEventTypesData?.allEventTypeCategoryOptions || null,
          allEventOptions: supportedEventTypesData?.allEventOptions || null,
          productCategories: supportedEventTypesData?.productCategories || null,
          productNames: supportedEventTypesData?.productNames || null,
          businessContextId: supportedEventTypesData?.businessContextId || null,
          isLoading: false,
          error: null
        }
      };

    case actions.GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_FAILED:
      return {
        ...state,
        supportedEventTypes: {
          ...state.supportedEventTypes,
          isLoading: false,
          error: action.payload
        }
      };

    case actions.RESET_COPY_MODAL_STORE:
      return initialState;

    default:
      return state;
  }
}